<template>
    <div class="step-template">
        <div class="text-wrapper">
            <div class="left-wrapper">
                <h1>Tägliche Tipps</h1>
                <p class="h2">Die Nutzenden werden bei den erforderlichen Lebensstiländerungen unterstützt...</p>
            </div>
            <div class="right-wrapper">
                <h2>Tägliches Engagement</h2>
                <p class="text">Tägliche Tipps fördern das Engagement der Patientinnen und Patienten und tragen zu einer kontinuierlichen Verhaltensänderung bei.</p>
            </div>
        </div>

        <MobileTemplate @app-step-from-mobile-template="actualStep" :appStep="appStep" />
    </div>
</template>

<script>
export default {
    data(){
        return {
            appStep: 13
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}
</script>

